import { FC } from 'react'

import {
  FreeformTextareaEditor,
  FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const PythonEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language={'python'} />
)
